import React, { useState } from "react";

import PartnersSales from "./PartnerSales";
import PartnersList from "./PartnersList";

const RefernEarnPartners = () => {
  const [currentScreen, setCurrentScreen] = useState({
    name: "list",
    data: null,
  });

  return (
    <div>
      {currentScreen.name === "list" ? (
        <PartnersList
          setCurrentScreen={setCurrentScreen}
          screenData={currentScreen.data}
        />
      ) : (
        currentScreen.name === "sales" && (
          <PartnersSales
            setCurrentScreen={setCurrentScreen}
            screenData={currentScreen.data}
          />
        )
      )}
    </div>
  );
};

export default RefernEarnPartners;
